export default function GreenChecked({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5" y="5" width="56" height="56" rx="28" fill="#D1FADF" />
      <path
        d="M27.7497 33L31.2497 36.5L38.2497 29.5M44.6663 33C44.6663 39.4433 39.443 44.6666 32.9997 44.6666C26.5564 44.6666 21.333 39.4433 21.333 33C21.333 26.5567 26.5564 21.3333 32.9997 21.3333C39.443 21.3333 44.6663 26.5567 44.6663 33Z"
        stroke="#039855"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="5"
        y="5"
        width="56"
        height="56"
        rx="28"
        stroke="#ECFDF3"
        strokeWidth="10"
      />
    </svg>
  );
}
